/** Maps ODS rows ({ minAmount, maxAmount, deliveryPrice }) to checkout tier shape. */
export function mapDeliveryPricesToTiers(data) {
  const rows = Array.isArray(data) ? data : [];
  const tiers = [];
  for (const row of rows) {
    const minCartTotal = Number(row.minAmount);
    const price = Number(row.deliveryPrice);
    if (Number.isFinite(minCartTotal) && Number.isFinite(price)) {
      tiers.push({ minCartTotal, price });
    }
  }
  return tiers.length ? tiers : null;
}
